/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import * as React from 'react';
import { Inbox } from '@jda/lui-common-icon-library-mui5';
import { Box, Card, CardContent } from "@mui/material";
import { LuiListCollector } from "@jda/lui-common-component-library-mui5";

import { useStyles } from '../../../shared/PolicyDialog/styles';
import { EMPTY_LIST_SUB_TITLE, EMPTY_LIST_TITLE } from '../../../shared/PolicyDialog/constants';

interface IMeasureListSelectorProps {
  measuresArray: any[],
  onChange: any,
};

const MeasuresListSelecter = ({ measuresArray, onChange }: IMeasureListSelectorProps) => {
  const { classes } = useStyles();
  return (
    <Box overflow="hidden">
      <Box>
        <Card>
          <CardContent>
            <Box my={1}>
              <LuiListCollector
                listData={measuresArray}
                displayNameProperty="id"
                height={400}
                width={380}
                onLoadSubmit={false}
                leftListLabel="Available Measures"
                rightListLabel="In Use Measures"
                leftListEmptyMessage={
                  <Box className={classes.innerContent} id="empty-component">
                    <Inbox fontSize="large" color="action" />
                    <Box id="empty-component-text" className={classes.titleAlignment}>
                      {EMPTY_LIST_TITLE}
                    </Box>
                  </Box>
                }
                rightListEmptyMessage={
                  <Box className={classes.innerContent} id="empty-component">
                    <Inbox fontSize="large" color="action" />
                    <Box id="empty-component-text" className={classes.titleAlignment}>
                      {EMPTY_LIST_TITLE}
                    </Box>
                    <Box id="empty-component-title">{EMPTY_LIST_SUB_TITLE}</Box>
                  </Box>
                }
                onSubmit={(items) => {
                  onChange(items);
                }}
                allowClearAll
                allowAddAll
                itemKey="value"
                divider={true}
                allowSearch={true}
                isDraggable={true}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
};

export { MeasuresListSelecter };